import BaseModel from "../base_model.js";

import { InputLabelDisplayModeAbove } from "../../base/inputs/constants.js";

class RawSignInInfoModel extends BaseModel {

  rawFormFields(item = undefined) {
    return [
      {
        name: "email",
        displayName: this.fieldDisplayName("email"),
        type: "email",
        displayNamePosition: InputLabelDisplayModeAbove
      },
      {
        name: "password",
        displayName: this.fieldDisplayName("password"),
        type: "password",
        displayNamePosition: InputLabelDisplayModeAbove
      }
    ]
  }

  i18nScope() {
    return "model.users.user";
  }

}
const SignInInfoModel = new RawSignInInfoModel();

export { RawSignInInfoModel, SignInInfoModel }

